import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import {
  Copy, ExternalLink, Pencil, Trash2,
  MapPin, UserCheck, Shuffle, HandMetal, Globe,
} from "lucide-react";

export const ROUTING = {
  specific: { label: "Specific rep", icon: UserCheck, color: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  round_robin: { label: "Round-robin", icon: Shuffle, color: "bg-teal-50 text-teal-700 border-teal-200" },
  geography: { label: "By geography", icon: MapPin, color: "bg-amber-50 text-amber-700 border-amber-200" },
  manual: { label: "Manual", icon: HandMetal, color: "bg-slate-50 text-slate-600 border-slate-200" },
};

export function FormCard({ f, teamName, openEdit, remove, linkFor, codeFor, copy }) {
  const R = ROUTING[f.routing_mode] || ROUTING.specific;
  const RIcon = R.icon;
  return (
    <Card data-testid={`form-card-${f.form_id}`} className="border-slate-200 shadow-sm">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: `${f.primary_color}22` }}>
              <Globe className="w-4 h-4" style={{ color: f.primary_color }} />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <p className="text-sm font-semibold">{f.name}</p>
                {!f.active && <Badge variant="outline" className="text-[9px] h-4 bg-slate-50 text-slate-500">Inactive</Badge>}
              </div>
              <p className="text-[11px] text-muted-foreground">{f.form_title}</p>
              <div className="flex items-center gap-1.5 mt-1">
                <Badge variant="outline" className={`text-[9px] h-4 ${R.color}`}><RIcon className="w-2.5 h-2.5 mr-0.5" />{R.label}</Badge>
                {f.routing_mode === "specific" && f.assigned_user_id && <span className="text-[10px] text-muted-foreground">→ {teamName(f.assigned_user_id)}</span>}
                {f.routing_mode === "round_robin" && <span className="text-[10px] text-muted-foreground">{(f.pool_user_ids || []).length} reps</span>}
                {f.routing_mode === "geography" && <span className="text-[10px] text-muted-foreground">{(f.geo_rules || []).length} rules</span>}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-1.5">
            <Button data-testid={`edit-form-${f.form_id}`} size="sm" variant="outline" className="h-7 text-[11px]" onClick={() => openEdit(f)}><Pencil className="w-3 h-3 mr-1" />Edit</Button>
            <Button data-testid={`delete-form-${f.form_id}`} size="sm" variant="outline" className="h-7 text-[11px] text-rose-600 border-rose-200 hover:bg-rose-50" onClick={() => remove(f.form_id)}><Trash2 className="w-3 h-3" /></Button>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-2 pt-1 border-t border-slate-100">
          <div>
            <Label className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Direct Link</Label>
            <div className="flex gap-2 mt-1">
              <Input value={linkFor(f.form_id)} readOnly className="bg-slate-50 text-xs font-mono h-8" />
              <Button variant="outline" size="sm" className="h-8 shrink-0" onClick={() => copy(linkFor(f.form_id), "Link")}><Copy className="w-3.5 h-3.5" /></Button>
              <a href={linkFor(f.form_id)} target="_blank" rel="noopener noreferrer"><Button variant="outline" size="sm" className="h-8 shrink-0"><ExternalLink className="w-3.5 h-3.5" /></Button></a>
            </div>
          </div>
          <div>
            <Label className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Embed Code</Label>
            <div className="relative mt-1">
              <Textarea value={codeFor(f)} readOnly className="bg-slate-50 text-[10px] font-mono h-20 resize-none" />
              <Button variant="outline" size="sm" className="absolute top-1.5 right-1.5 h-6 text-[10px]" onClick={() => copy(codeFor(f), "Embed code")}><Copy className="w-3 h-3 mr-1" />Copy</Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
